import { ForecastVerticalDetailBase } from './base/forecast-vertical-detail-base';

export class ForecastVerticalDetail extends ForecastVerticalDetailBase { }